import axios from "axios";
import authHeader from "@/services/auth-header";

const main = "BytePro";
const sub = "UserOrgProfile";

class UserOrgProfileService {
  // Fetch list of UserOrgProfiles by userId
  getUserOrgProfiles(userId) {
    return axios
      .get(`${process.env.VUE_APP_API_BASE_URL}/api/${main}/${sub}/${userId}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }

  // Fetch a single UserOrgProfile by userId, organizationId, and securityProfileId
  getUserOrgProfile(userId, organizationId, securityProfileId) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/${main}/${sub}/${userId}/${organizationId}/${securityProfileId}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }

  // Create a new UserOrgProfile
  createUserOrgProfile(userOrgProfile) {
    return axios
      .post(
        `${process.env.VUE_APP_API_BASE_URL}/api/${main}/${sub}`,
        userOrgProfile,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }

  // Update an existing UserOrgProfile by userOrgProfileId
  updateUserOrgProfile(userOrgProfileId, updatedUserOrgProfile) {
    return axios
      .put(
        `${process.env.VUE_APP_API_BASE_URL}/api/${main}/${sub}/${userOrgProfileId}`,
        updatedUserOrgProfile,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }

  // Delete a UserOrgProfile by userOrgProfileId
  deleteUserOrgProfile(userOrgProfileId) {
    return axios
      .delete(
        `${process.env.VUE_APP_API_BASE_URL}/api/${main}/${sub}/${userOrgProfileId}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }
}

export default new UserOrgProfileService();
